function getTendencyClass(increase) {
  if (typeof increase === 'undefined' || increase === null) {
    return 'even';
  }
  return increase ? 'up' : 'down';
}

function hasIncrease(prevValue, currentValue) {
  if (prevValue === currentValue) {
    return null;
  }
  return currentValue > prevValue;
}

module.exports = {
  getTendencyClass,
  hasIncrease,
};
